import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderListingContext } from "../context/OrderListingContext";
import { ApproveOrderDeliveriesDialog } from "./ApproveOrderDeliveriesDialog";

export const ApproveOrderDeliveriesButton: React.VFC = () => {
    const { selectedItems } = useContext(OrderListingContext);
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton
                text="Approve deliveries"
                icon="Stack"
                disabled={!selectedItems.length}
                onClick={onOpen}
                styles={{ root: { width: 160 } }}
                testId="approve-deliveries-button"
            />
            <ApproveOrderDeliveriesDialog key={String(isOpen)} isOpen={isOpen} onClose={onClose} />
        </AuthorizationWrapper>
    );
};
